/** Matches Filevault Sidebar brand (camera + flower logo) */
export const THEME = {
  primary: "#2563eb",
  primaryLight: "#3b82f6",
  primaryDark: "#1d4ed8",
  lens: "rgba(37, 99, 235, 0.83)",
  flashBg: "#eff6ff",
  glassBgLight: "rgba(255, 255, 255, 0.95)",
  border: "#e2e8f0",
  borderLight: "#f1f5f9",
  shadowMedium: "0 10px 32px rgba(15, 23, 42, 0.1)",
  shadowSoft: "0 4px 20px rgba(37, 99, 235, 0.08)",
  textPrimary: "#0f172a",
  textSecondary: "#64748b",
  pageBg: "#f8fafc",
};
